import React from "react";
import MicrosoftLogin from "react-microsoft-login";
import login from '../../actionCreators/login'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.authHandler = this.authHandler.bind(this);
    }

    authHandler () {
        const date = new Date();
        date.setTime(date.getTime() + 3600000);
        document.cookie = "idtoken=" + sessionStorage["msal.idtoken"] + "; expires=" + date.toUTCString() + "; path =/";
        this.props.login();
    }

    render() {
        return (
            <MicrosoftLogin
                clientId= "009d0fb1-ea20-47a1-9f30-8702cb9d7ecb"
                authCallback={this.authHandler}
            />
        )
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        login: login
    }, dispatch);
}

export default connect(null, matchDispatchToProps)(Login);

// import React from 'react'
// import RomanianPackage from '../../languages/RomanianPackage'
// import login from '../../actionCreators/login'
// import {bindActionCreators} from 'redux';
// import {connect} from 'react-redux';
// import ReducerPHPURL from '../../reducers/ReducerPHPURL'

// class Login extends React.Component {

//     constructor(props) {
        
//         super(props);

//         this.state = {
//             username: '',
//             password: ''
//         };

//         this.handleSubmit = this.handleSubmit.bind(this);
//         this.handleChange = this.handleChange.bind(this);

//     }

//     handleSubmit(e) {

//         e.preventDefault();

//         let phpPath = ReducerPHPURL.baseURL + ReducerPHPURL.login;
//         let formData = JSON.stringify(this.state);

//         this.props.login(phpPath, formData);

//     }
    
//     handleChange(event) {

//         this.setState({[event.target.name]: event.target.value})
//     }
    
//     render() {
// 		return (
// 			<div>
// 				<form onSubmit={this.handleSubmit}>
//                     <label>{RomanianPackage.USERNAME}</label>
//                     <input name="username" type="string" value={this.state.username} onChange={this.handleChange} />
//                     <label>{RomanianPackage.PASSWORD}</label>
//                     <input name="password" type="password" value={this.state.password} onChange={this.handleChange} />
//                     <input type="submit" value = {RomanianPackage.SUBMIT}/>
//                 </form>
// 			</div>
// 		);
// 	}
// }

// function matchDispatchToProps(dispatch) {
//     return bindActionCreators({
//         login: login
//     }, dispatch);
// }

// export default connect(null, matchDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/login/Login.js